import {
  Link2Icon,
  LinkBreak2Icon,
  LinkNone2Icon,
} from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { HitterRosterStatus } from 'lib_ts/enums/hitters.enums';
import { RADIX, RadixColor } from 'lib_ts/enums/radix-ui';
import { ReactNode, useMemo } from 'react';

export const HitterRosterStatusIcon = (props: {
  status: HitterRosterStatus | undefined;
}) => {
  const def = useMemo((): {
    title: string;
    icon: ReactNode;
    color: RadixColor;
  } => {
    switch (props.status) {
      case HitterRosterStatus.OnRoster: {
        return {
          title:
            'This hitter was part of your active roster as of the latest import',
          icon: <Link2Icon />,
          color: RADIX.COLOR.SUCCESS,
        };
      }

      case HitterRosterStatus.OffRoster: {
        return {
          title:
            'This hitter was not part of your active roster as of the latest import',
          icon: <LinkBreak2Icon />,
          color: RADIX.COLOR.DANGER,
        };
      }

      case HitterRosterStatus.NA:
      default: {
        return {
          title: 'This hitter was not created via automatic import',
          icon: <LinkNone2Icon />,
          color: RADIX.COLOR.NEUTRAL,
        };
      }
    }
  }, [props.status]);

  return (
    <IconButton
      className="btn-floating"
      variant={RADIX.BUTTON.VARIANT.BORDERLESS}
      color={def.color}
      title={def.title}
    >
      {def.icon}
    </IconButton>
  );
};
